'use strict';

const fakeWidget = require('./fake_widget');
const logger = require('od-modules/utils/logger');

const widgets = {};

module.exports = (widgetDefs) => {
    const getWidget = (id, widgetFactory, options) => {
        if (widgetFactory) {
            widgets[id] = widgets[id] || widgetFactory.create(Odigeo._.extend({}, {options, id}));
            return widgets[id];
        }
        return fakeWidget;
    };

    const getAsyncWidget = (id, factoryPromise, options, callBack) => {
        factoryPromise.then((widgetFactory) => {
            getWidget(id, widgetFactory, options);
        });

        return {
            execute: function() {
                return callBack('execute', arguments);
            },
            get: function() {
                return callBack('get', arguments);
            },
        };
    };

    return {
        get(alias, id) {
            const [widgetId, factory, options] = widgetDefs[alias] || [];
            const isPromise = factory instanceof Promise;
            id = id || widgetId;

            const callMethod = (method, args) => {
                return factory.then((widgetFactory) => {
                    const widget = getWidget(id, widgetFactory, options);
                    return widget[method].apply(widget, args);
                }).catch((error) => {
                    logger.error(error, 'error loading factory: ' + id);
                    return fakeWidget[method].apply(fakeWidget, args);
                });
            };

            if (!isPromise) {
                return getWidget(id, factory, options);
            } else {
                return getAsyncWidget(id, factory, options, callMethod);
            }
        },
        remove(alias, widgetName = '') {
            const [widgetId, factory] = widgetDefs[alias] || [];
            const isPromise = factory instanceof Promise;
            if (!isPromise) {
                if (widgetName) {
                    Odigeo.Templates.removeWidgetResource(widgetName);
                }
                if (widgets[widgetId]) {
                    widgets[widgetId].destroy();
                    delete widgets[widgetId];
                }
            }
        },
    };
};
